import { createAction } from 'redux-actions';
import { FormNames } from '~/constants';

const createSetDraftAction = (formName) =>
  createAction('app/SET_CHANNEL_DRAFT', (data) => ({ ...data, formName }));

const createResetDraftAction = (formName) =>
  createAction('app/RESET_CHANNEL_DRAFT', ({ draftFields } = {}) => ({
    formName,
    draftFields,
  }));

export const setWAChannelDraft = createSetDraftAction(
  FormNames.CREATE_WA_CHANNEL
);
export const resetWAChannelDraft = createResetDraftAction(
  FormNames.CREATE_WA_CHANNEL
);

export const setTGChannelDraft = createSetDraftAction(
  FormNames.CREATE_TG_CHANNEL
);
export const resetTGChannelDraft = createResetDraftAction(
  FormNames.CREATE_TG_CHANNEL
);

export const setSMSChannelDraft = createSetDraftAction(
  FormNames.CREATE_SMS_CHANNEL
);
export const resetSMSChannelDraft = createResetDraftAction(
  FormNames.CREATE_SMS_CHANNEL
);

export const setVIChannelDraft = createSetDraftAction(
  FormNames.CREATE_VI_CHANNEL
);
export const resetVIChannelDraft = createResetDraftAction(
  FormNames.CREATE_VI_CHANNEL
);

export const setRCSChannelDraft = createSetDraftAction(
  FormNames.CREATE_RCS_CHANNEL
);
export const resetRCSChannelDraft = createResetDraftAction(
  FormNames.CREATE_RCS_CHANNEL
);

export const setWeChatChannelDraft = createSetDraftAction(
  FormNames.CREATE_WECHAT_CHANNEL
);
export const resetWeChatChannelDraft = createResetDraftAction(
  FormNames.CREATE_WECHAT_CHANNEL
);

export const setCurrentChannel = createAction(
  'app/SET_CURRENT_CHANNEL',
  (currentChannel) => currentChannel
);
